import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components_v2/common/ImageV2';

const TimelineImage = props => {
  const {
    data: { msid, title, imgsize, smalldesc },
    width,
    showImagedesc,
  } = props;
  //         smalldesc={item.smalldesc}

  return (
    <>
      <Image
        key={msid}
        msid={msid}
        width={width || 500}
        placeHolderSrc="https://static.toiimg.com/photo/83033472.cms"
        altTitle={title}
        imgsize={imgsize}
        lazyload
        //onError={customOnError}
        offsetVertical={300}
      />
      {showImagedesc &&
        smalldesc && (
          <p
            dangerouslySetInnerHTML={{
              __html: smalldesc,
            }}
          />
        )}
    </>
  );
};

TimelineImage.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    msid: PropTypes.string,
    imgsize: PropTypes.string,
    smalldesc: PropTypes.string,
  }).isRequired,
  width: PropTypes.number,
  showImagedesc: PropTypes.bool,
};
TimelineImage.defaultProps = {
  width: null,
  showImagedesc: false,
};

export default TimelineImage;
